import { render, staticRenderFns } from "./c-like.vue?vue&type=template&id=7c49c23a&scoped=true&"
import script from "./c-like.vue?vue&type=script&lang=js&"
export * from "./c-like.vue?vue&type=script&lang=js&"
import style0 from "./c-like.vue?vue&type=style&index=0&id=7c49c23a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c49c23a",
  null
  
)

export default component.exports